import { React } from "react";
function Student()
{
    return(
        <div><center><h1>This is Student Component</h1></center>
        <hr/>
        </div>
    )
}
export default Student;